// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourResponse

import { OpeningHourType, OpeningHourEntityType } from './enums.gen';
import { hydrateOpeningHourSchedule, type OpeningHourSchedule, type OpeningHourScheduleApiResponse } from './openingHourSchedule.gen';

export type OpeningHourApiResponse = {
	id: string;
	type: OpeningHourType;
	name: string;
	schedule: OpeningHourScheduleApiResponse[];
	scheduleFollowStandardWeek: boolean;
	color: string | null;
	entityType: OpeningHourEntityType;
	entityId: string | null;
	override: string | null;
};

export type OpeningHour = {
	id: string;
	type: OpeningHourType;
	name: string;
	schedule: OpeningHourSchedule[];
	scheduleFollowStandardWeek: boolean;
	color: string | null;
	entityType: OpeningHourEntityType;
	entityId: string | null;
	override: string | null;
};

export function hydrateOpeningHour(data: OpeningHourApiResponse): OpeningHour {
	return {
		...data,
		schedule: data.schedule.map(hydrateOpeningHourSchedule),
	};
}